/**
 *    App - Background
 */

(function ($) {
  Drupal.behaviors.appBackground = {
    attach(context) {
      const $container = $(context).find('.vb-bg-newsletter, .vb-bg-convention-kit, .vb-bg-berlin-silhouette, .vb-bg-download');
      const path = $(document.documentElement).data('path');

      $container.each((index, element) => {
        Drupal.behaviors.appBackground.observeBackground(element, path);
      });
    },

    observeBackground(element, path) {
      let observer;

      function handleIntersection(entries) {
        entries.map((entry) => {
          if (entry.isIntersecting) {
            Drupal.behaviors.appBackground.loadBackground(entry.target, path);
            observer.unobserve(entry.target);
          }
          return true;
        });
      }

      observer = new IntersectionObserver(handleIntersection, {
        // root: document,
        rootMargin: '0px 0px 0px 0px',
        threshold: 0,
      });

      observer.observe(element);
    },

    loadBackground(target, path) {
      const targetEl = target;

      if (targetEl.classList.contains('vb-bg-newsletter')) {
        targetEl.style.backgroundImage = `url('${path}/dist/img/bg-newsletter.webp')`;
      }

      if (targetEl.classList.contains('vb-bg-convention-kit')) {
        targetEl.style.backgroundImage = `url('${path}/dist/img/bg-convention-kit.webp')`;
      }

      if (targetEl.classList.contains('vb-bg-download')) {
        targetEl.style.backgroundImage = `url('${path}/dist/img/bg-downloads.webp')`;
      }

      if (targetEl.classList.contains('vb-bg-berlin-silhouette')) {
        targetEl.style.backgroundImage = `url('${path}/dist/img/bg-berlin-silhoutte.svg')`;
      }
    },
  };
}(jQuery));
